@if (markUpContent$ | async; as syndicateSummary) {
  <ion-content>
    <div class="detailImgText" [innerHTML]="syndicateSummary"></div>
    @if (!syndicateList) {
      <ion-spinner name="lines-small" class="sign-in-spinner" duration="2000"
      style="color: blue; width:100%"></ion-spinner>
    }
    @if (syndicateList) {
      <div class="tableMain">
        <table style="width: 100%">
          <tr>
            <th class="head lefthead">{{ "syndicate-summary.lottery" | translate }}</th>
            <th class="lefthead">{{ "syndicate-summary.claim_reference" | translate }}</th>
            <th class="righthead">{{ "syndicate-summary.date" | translate }}</th>
          </tr>
          @for (syndicate of syndicateList; track syndicate) {
            <tr class="font-size">
              <td class="lefthead">{{syndicate?.lottery_name}}</td>
              <td class="lefthead">{{syndicate?.claim_ref}}</td>
              <td class="righthead">{{syndicate?.date}}</td>
            </tr>
          }
        </table>
      </div>
    }
    <div class="footer-content" slot="fixed">
      <a class="text-link back-to-login" (click)="dismissBottomSheet()">
      &larr; {{ "syndicate-summary.Back" | translate }}</a>
    </div>
  </ion-content>
} @else {
  <app-in-progress-animation></app-in-progress-animation>
}


